import React, { SyntheticEvent } from "react";

import { Checkbox, Form, FormField, FormGroup, Input } from "semantic-ui-react";

import ModConfirmCNMI from "react-lib/apps/common/cnmi/ModConfirm";
import TimeComboBox from "react-lib/apps/common/TimeComboBox";

import { ClockRecordType } from "./sequence/EmployeeTA";

// Types
type ModEditTimeProps = {
  editData: ClockRecordType;
  open: boolean;
  selectedData: ClockRecordType;
  onChange: (e: SyntheticEvent | null, data: Record<string, any>) => void;
  onClose: () => void;
  onSave: () => void;
};

const ModEditTime = (props: ModEditTimeProps) => (
  <ModConfirmCNMI
    testId="-EditTime"
    approveButtonColor="yellow"
    approveButtonStyle={{ minWidth: "max-content" }}
    approveButtonText="CONFIRM EDITING"
    backgroundColor="rgba(93, 188, 210, 1)"
    denyButtonText="CLOSE"
    modalStyle={{ minWidth: "35rem" }}
    openModal={props.open}
    titleName="Edit Time"
    onApprove={props.onSave}
    onCloseWithDimmerClick={props.onClose}
    onDeny={props.onClose}
    content={
      <>
        <div id="ModEditTime-Div-Title" style={{ fontWeight: "bold", margin: "-1rem 0 0.25rem" }}>
          {props.selectedData.type === "I" ? "Clock-in" : "Clock-out"}
        </div>
        <Form>
          <FormGroup inline>
            <FormField width={7} inline>
              <label style={{ fontWeight: "normal", minWidth: "max-content" }}>Time : </label>
              <Input value={props.selectedData.time} disabled fluid />
            </FormField>
            <FormField width={9} inline>
              <label id="ModEditTime-Label-EditTime" style={{ fontWeight: "normal", minWidth: "max-content" }}>Edit time : </label>
              <TimeComboBox
                id="ModEditTtime-TimeComboBox-EditTime"
                style={{ width: "100%" }}
                defaultValue={props.editData.time}
                onTextChange={(value: any) => {
                  props.onChange(null, { name: "time", value });
                }}
              />
            </FormField>
            <FormField>
              <Checkbox
                id="ModEditTime-Checkbox-Active"
                checked={["", "M"].includes(props.editData.status || "")}
                disabled={props.selectedData.status === "M"}
                label="Active"
                name="status"
                onChange={props.onChange}
              />
            </FormField>
          </FormGroup>
          <FormGroup style={{ marginBottom: "-1rem" }} inline>
            <FormField width={16} required>
              <label style={{ fontWeight: "normal", minWidth: "max-content" }}>Reason : </label>
              <Input id="ModEditTime-Input-Reason" name="reason" fluid onChange={props.onChange} />
            </FormField>
          </FormGroup>
        </Form>
      </>
    }
  />
);

ModEditTime.displayName = "ModEditTime";

export default React.memo(ModEditTime);
